import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { PageHeader } from '@/components/ui-kit/PageBits';
import { Badge } from '@/components/ui/badge';
import { ScrollText } from 'lucide-react';

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get('/audit-logs').then(r => setLogs(r.data)); }, []);
  return (
    <div className="p-8 max-w-6xl mx-auto">
      <PageHeader title="Registro de auditoría" subtitle={`${logs.length} eventos registrados`} testId="audit-header"/>
      {logs.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-slate-300 p-12 text-center text-sm text-slate-500">
          <ScrollText className="w-8 h-8 mx-auto mb-2 text-slate-400"/>
          Aún no hay acciones registradas. Las acciones administrativas aparecerán aquí.
        </div>
      ) : (
        <div className="rounded-2xl bg-white border border-slate-200 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-xs uppercase tracking-widest text-slate-500 font-bold">
              <tr>
                <th className="text-left p-3">Fecha</th>
                <th className="text-left p-3">Usuario</th>
                <th className="text-left p-3">Rol</th>
                <th className="text-left p-3">Acción</th>
                <th className="text-left p-3">Detalles</th>
              </tr>
            </thead>
            <tbody>
              {logs.map(l => (
                <tr key={l.id} data-testid={`audit-${l.id}`} className="border-t hover:bg-slate-50">
                  <td className="p-3 font-mono text-xs text-slate-500">{new Date(l.created_at).toLocaleString()}</td>
                  <td className="p-3 font-mono text-slate-700">{l.user_email}</td>
                  <td className="p-3"><Badge variant="secondary" className="capitalize">{l.user_role?.replace('_',' ')}</Badge></td>
                  <td className="p-3 font-mono text-blue-700">{l.action}</td>
                  <td className="p-3 text-slate-600 font-mono text-xs">{JSON.stringify(l.details)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
